import React from "react";
import { Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import tw from "twrnc";

import { colors } from "./theme";

// Icon-only action in a row or card (remove, edit, open): 32 px, slate icon,
// a light shade on hover/press that works on white and grey cards alike.
// Always pass a label; it is what screen readers say.
const IconButton = ({
  icon,
  label,
  onPress,
  color = colors.slate,
  size = 18,
  disabled,
  style,
}) => (
  <Pressable
    onPress={onPress}
    disabled={disabled}
    accessibilityRole="button"
    accessibilityLabel={label}
    accessibilityState={{ disabled: !!disabled }}
    hitSlop={6}
    style={({ hovered, pressed }) => [
      tw`items-center justify-center rounded-md`,
      { width: 32, height: 32 },
      (hovered || pressed) &&
        !disabled && {
          backgroundColor: colors.pressOverlay,
        },
      disabled && { opacity: 0.4 },
      style,
    ]}
  >
    <Ionicons name={icon} size={size} color={color} />
  </Pressable>
);

export default IconButton;
